import { logUserEvent } from '@analytics/amplifyLogging';
import { selectLoan } from '@store/selectors/widgets.selectors';
import { Identifier } from '@types';
import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { EventType } from 'shared-ui-components';
import { NaturalDisasterAlertScreen, NaturalDisasterAlertScreenProps } from 'shared-ui-components';
import { v4 } from 'uuid';

const NaturalDisasterAlertComponent = ({ setDisasterAlert, loanNumber }: { setDisasterAlert: any; loanNumber: string }) => {
    const loanList: Identifier[] = useSelector(selectLoan);
    const selectedLoan = loanList.find(loanlist => loanlist.identifier === loanNumber);
    const { address1, address2 } = selectedLoan.propertyAddress;

    const userEvents = useCallback((event: EventType) => {
        logUserEvent({
            action: event.action,
            loanNumber: loanNumber,
            description: event.description,
            type: 'Natural Disaster Alert Component'
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        userEvents({
            action: 'NaturalDisasterFlowDisplayed',
            type: 'Natural Disaster',
            description: 'Disaster Declaration flow displayed'
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const naturalDisasterAlertProps: NaturalDisasterAlertScreenProps = {
        logUserEvent: userEvents,
        metadata: {
            title: {
                metadata: [
                    {
                        text: `You have been identified as being located in a natural disaster area. \nHas your home at `
                    },
                    {
                        text: `${address1} ${address2}`,
                        textProps: { fontWeight: 'bold' }
                    },
                    {
                        text: 'or your '
                    },
                    {
                        text: 'workplace ',
                        textProps: { fontWeight: 'bold' }
                    },
                    {
                        text: 'been affected?'
                    }
                ]
            },
            heading: ''
        },
        valueKey: 'borrowerImpacted',
        onSelection: (e: any) => {
            if (e.borrowerImpacted === 'Y') {
                setDisasterAlert({ borrowerImpacted: 'Y', showAlert: false });
            } else {
                setDisasterAlert({ borrowerImpacted: 'N', showAlert: false });
            }
        }
    };

    return (
        <>
            <div style={{ textAlign: 'center', padding: '0 30px 30px 30px', backgroundColor: '#fff' }}>
                <NaturalDisasterAlertScreen {...naturalDisasterAlertProps} />
            </div>
        </>
    );
};

export default React.memo(NaturalDisasterAlertComponent);
